module.exports = __webpack_public_path__ + "static/media/playcz_small.73f59c8d.png";